import { render, staticRenderFns } from "./HomeViewPaoTangVer.vue?vue&type=template&id=08df466a&scoped=true"
import script from "./HomeViewPaoTangVer.vue?vue&type=script&lang=js"
export * from "./HomeViewPaoTangVer.vue?vue&type=script&lang=js"
import style0 from "./HomeViewPaoTangVer.vue?vue&type=style&index=0&id=08df466a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df466a",
  null
  
)

export default component.exports